document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-scroll-to-offer]').forEach(function(el){
    el.addEventListener('click',function(e){
      var id=el.getAttribute('href');
      if(id&&id.charAt(0)==='#'){
        var target=document.querySelector(id);
        if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth'});}
      }
    });
  });
});

/* Cocina Sana — solo el CTA final abre settings.checkout_url; los demás llevan al CTA final. */
